import { useTranslation } from 'react-i18next';
import './customer-stories.scss';
import utils from '../core/utils';
import { Dispatch, SetStateAction } from 'react';

import leftArrow from '../assets/icon/left-arrow.svg';
import rightArrow from '../assets/icon/right-arrow.svg';

import bg from '../assets/background/bg-customer-issue.jpg';

import { useRef } from 'react';

import { motion } from 'framer-motion';
import { motionX, motionY } from 'src/core/animation';
import { useState } from 'react';

const CustomerStories = ({ setInquiryPopup }: { setInquiryPopup: Dispatch<SetStateAction<boolean>> }) => {
  return (
    <section id="customer stories" className="CustomerStories">
      <InterviewSection />
      <InquirySection setInquiryPopup={setInquiryPopup} />
    </section>
  );
};

const InterviewSection = () => {
  const slideRef = useRef<HTMLDivElement>(null);

  const scrollToLeft = () => {
    if (slideRef.current) {
      slideRef.current.scrollTo({
        top: slideRef.current.scrollTop,
        left: slideRef.current.scrollLeft - 200,
        behavior: 'smooth',
      });
    }
  };

  const scrollToRight = () => {
    if (slideRef.current) {
      slideRef.current.scrollTo({
        top: slideRef.current.scrollTop,
        left: slideRef.current.scrollLeft + 200,
        behavior: 'smooth',
      });
    }
  };

  const { t } = useTranslation();

  return (
    <section className="interview-section">
      <div className="text-section">
        <motion.div
          className="text-box"
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: false, amount: 0.3 }}
          variants={motionX({ from: -100, to: 0 })}
        >
          <div className="point-text">{t('customer-stories.interview-section.title-0')}</div>
          <div className="big-text">{t('customer-stories.interview-section.title-1')}</div>
          <div className="big-text">{t('customer-stories.interview-section.title-2')}</div>
        </motion.div>
        <div className="icon-list">
          <motion.div className="icon-box" onClick={scrollToLeft} whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }}>
            <img className="icon" src={leftArrow} />
          </motion.div>
          <motion.div
            className="icon-box"
            onClick={scrollToRight}
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.8 }}
          >
            <img className="icon" src={rightArrow} />
          </motion.div>
        </div>
      </div>
      <motion.div
        className="slide-section"
        ref={slideRef}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionX({ from: 100, to: 0 })}
      >
        <div className="card-box">
          <div className="top">
            <div className="big-text">{t('customer-stories.interview-section.card-0.text-0')}</div>
          </div>
          <div className="middle">
            <div className="small-text">{t('customer-stories.interview-section.card-0.text-1')}</div>
          </div>
          <div className="bottom">
            <div className="point-text">{t('customer-stories.interview-section.card-0.text-2')}</div>
          </div>
        </div>
        <div className="card-box">
          <div className="top">
            <div className="big-text">{t('customer-stories.interview-section.card-1.text-0')}</div>
          </div>
          <div className="middle">
            <div className="small-text">{t('customer-stories.interview-section.card-1.text-1')}</div>
          </div>
          <div className="bottom">
            <div className="point-text">{t('customer-stories.interview-section.card-1.text-2')}</div>
          </div>
        </div>
        <div className="card-box">
          <div className="top">
            <div className="big-text">{t('customer-stories.interview-section.card-2.text-0')}</div>
          </div>
          <div className="middle">
            <div className="small-text">{t('customer-stories.interview-section.card-2.text-1')}</div>
          </div>
          <div className="bottom">
            <div className="point-text">{t('customer-stories.interview-section.card-2.text-2')}</div>
          </div>
        </div>
        <div className="card-box">
          <div className="top">
            <div className="big-text">{t('customer-stories.interview-section.card-3.text-0')}</div>
          </div>
          <div className="middle">
            <div className="small-text">{t('customer-stories.interview-section.card-3.text-1')}</div>
          </div>
          <div className="bottom">
            <div className="point-text">{t('customer-stories.interview-section.card-3.text-2')}</div>
          </div>
        </div>
        {/* <div className="card-box">
          <div className="top">
            <div className="big-text">{t('customer-stories.interview-section.card-4.text-0')}</div>
          </div>
          <div className="middle">
            <div className="small-text">{t('customer-stories.interview-section.card-4.text-1')}</div>
          </div>
          <div className="bottom">
            <div className="point-text">{t('customer-stories.interview-section.card-4.text-2')}</div>
          </div>
        </div> */}
      </motion.div>
    </section>
  );
};

const InquirySection = ({ setInquiryPopup }: { setInquiryPopup: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();

  return (
    <section className="inquiry-section">
      <img className="background-image" src={bg} />
      <motion.div
        className="content-box"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionY({
          transition: {
            type: 'tween',
            duration: 1.5,
          },
        })}
      >
        <div className="point-text">{t('customer-stories.inquiry-section.text-0')}</div>
        <div className="big-text">{t('customer-stories.inquiry-section.text-1')}</div>
        <div className="small-text">{t('customer-stories.inquiry-section.text-2')}</div>
        <hr />
        <motion.div
          className="inquiry-btn"
          onClick={() => {
            setInquiryPopup(true);
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {t('customer-stories.inquiry-section.btn-text-0')}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default CustomerStories;
